import { styled } from "styled-components";

import { CrossIcon, SectionTitleUnderlined, UIButton } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";
import { AddCustomKeyIssue } from "domains/customKeyIssue/components/AddCustomKeyIssue";

const StyledContainer = styled.div`
  padding-bottom: 1rem;
`;

const StyledClearButtonIcon = styled(CrossIcon)`
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: all 0.3s;
  margin-left: 0.5rem;
  color: ${({ theme }) => theme.colors.textFade};
  &:hover {
    color: ${({ theme }) => theme.colors.textBright};
  }
`;

type AddCustomKeyIssuePanelProps = { toggleVisibility: () => void };

export const AddCustomKeyIssuePanel = ({ toggleVisibility }: AddCustomKeyIssuePanelProps) => {
  const translate = useTranslate();

  return (
    <StyledContainer>
      <SectionTitleUnderlined rightElement={<StyledClearButtonIcon onClick={toggleVisibility} />}>
        {translate("app.custom_key_issue.create")}
      </SectionTitleUnderlined>
      <AddCustomKeyIssue />
      <UIButton fullwidth variant="outlined" onClick={toggleVisibility} style={{ marginTop: "1rem" }}>
        {translate("app.faq_teaser.dismiss")}
      </UIButton>
    </StyledContainer>
  );
};
